var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 px-sm-0",domProps:{"innerHTML":_vm._s(_vm.localize(_vm.value.title))}})}
var staticRenderFns = []

export { render, staticRenderFns }